import { CompRef } from '@wix/document-services-types';
import {
  WidgetPointer,
  PluginActionContext,
} from '@wix/editor-platform-host-integration-apis';

import { PlatformContext } from '../../../types/platformApi';
import { extendPluginActionContext } from './utils';
import { HeaderPluginsApi } from './types';
import { SlotPointer } from './slotPointer';

export class HeaderPluginService {
  api: HeaderPluginsApi;

  constructor(api: HeaderPluginsApi) {
    this.api = api;
  }

  public isHeaderPlugin(compRef: CompRef): boolean {
    return this.api.isHeaderPlugin(compRef);
  }

  public async installHeaderPlugin(
    context: PlatformContext,
    slotPointer: SlotPointer,
    widgetRef: WidgetPointer,
    pluginActionContext: PluginActionContext,
  ): Promise<CompRef> {
    const actionContext = extendPluginActionContext(pluginActionContext);
    return this.api.installHeaderPlugin(
      context,
      slotPointer,
      widgetRef,
      actionContext,
    );
  }
}
